import { HomeLinksSchema } from './HomeLinks.styles';

export const homeLinkStyles: HomeLinksSchema = {
  linkIconBoxOverride: {},
  linkOverlayOverride: { px: 4 },
  wrapper: {
    flexDirection: 'column',
    mt: [0, null, 2],
    mb: 2,
    px: ['1', null, '0'],
  },
  racingBtnsContainer: {
    mx: [1, null, null, 0],
    gap: '2',
    w: 'full',
    justifyContent: 'space-around',
    flexDirection: 'row',
  },
  sportBtnsContainer: {
    mx: [1, 0],
    flexDirection: 'row',
    w: ['100dvw', null, 'full'],
    maxW: ['100dvw', null, 'full'],
    justifyContent: ['unset', null, 'flex-start'],
    overflowX: 'auto',
    sx: {
      '&::-webkit-scrollbar': { display: 'none' },
    },
  },
  linkIconBox: {
    mx: '1',
    mt: ['1', null, '4'],
    w: 'full',
  },
  linkBox: { w: 'full' },
  linkOverlay: {
    display: 'flex',
    flexDirection: ['column', null, 'row'],
    p: '3',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1,
    borderRadius: 'md',
    bg: 'beta.400',
    boxShadow:
      '0px -3px 4px 0px rgba(0, 0, 0, 0.20) inset, 0px 4px 4px 0px rgba(255, 255, 255, 0.15) inset, 0px 4px 8px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.30) inset',
    color: 'alpha.600',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.30)',
    fontFamily: 'accent',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    fontSize: ['2xs', 'sm'],

    _hover: {
      bg: 'beta.600',
      boxShadow:
        '0px 1px 0px 0px rgba(255, 255, 255, 0.25), 0px 2px 4px 0px rgba(0, 0, 0, 0.25) inset',
      color: 'alpha.800',
      textShadow: '0px 1px 1px rgba(255, 255, 255, 0.30)',
    },
  },
  linkBoxText: {},
  racingIcon: {
    boxSize: 8,
    color: 'alpha.600',
    filter: 'drop-shadow(0px 1px 0px rgba(255, 255, 255, 0.30))',
    mr: 0,
  },
  sportIcon: {
    boxSize: 8,
    color: 'alpha.600',
    filter: 'drop-shadow(0px 1px 0px rgba(255, 255, 255, 0.30))',
    mr: 0,
  },
  sportIconOverride: {
    minW: 24,
    pt: 2,
    fontSize: 'sm',
  },
  racingHeader: {
    display: 'none',
  },
  sportsHeader: {
    display: 'none',
  },
};
